import * as moment from 'moment';
import { TimeRangeMoment } from 'src/app/model/time-range-moment';
export class DateRangeIntervals {
    intervals: Array<TimeRangeMoment> = new Array();
    constructor() {
        this.intervals.push(new TimeRangeMoment(moment().subtract(5, 'minute'), moment(), 'Last 5 minutes'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(15, 'minute'), moment(), 'Last 15 minutes'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(30, 'minute'), moment(), 'Last 30 minutes'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(1, 'hour'), moment(), 'Last Hour'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(6, 'hour'), moment(), 'Last 6 Hours'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(12, 'hour'), moment(), 'Last 12 Hours'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(1, 'day'), moment(), 'Last Day'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(1, 'week'), moment(), 'Last Week'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(1, 'month'), moment(), 'Last Month'));
        this.intervals.push(new TimeRangeMoment(moment().subtract(3, 'month'), moment(), 'Last 3 Months'));
    }
}